import type {SyntheticEvent} from 'react';

/**
 * Stop event propagation
 * @param event Event
 *
 * @example
 * ```ts
 * stopPropagation(event);
 * ```
 */
export const stopPropagation = <E extends SyntheticEvent | Event>(event: E) => {
	event.stopPropagation();
};

export default stopPropagation;
